/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {getSelectedProductIdFromActionInput,getSimpleProductsAction,ProductInput, DeliveryMode,
    ProductAvailabilitiesForSelectedVariantInput, getProductAvailabilitiesForSelectedVariant,
    IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';
import { IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { ProductSearchCriteria,ProductLookupClause,SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import {getByIdAsync, searchByCriteriaAsync} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { IAlternateItems } from '../modules/buybox/components/buybox-components';
import {IAlternateProduct} from '../themes/adventureworks/views/common/buyboxInterface';
import {getProductEtaAction,ProductEtaActionInput} from './product-eta-action.action';
import { getProductInfoAsync } from './getAlternateItemDetails';
/**
 * GetProductAlternateItem Input Action
 */
export class GetProductAlternateItemInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetProductAlternateItemData {
    respObj: IGetAlternateItemWithServiceResponse;
}

export interface IGetAlternateItemWithServiceResponse {
    product: IAlternateProduct | undefined;
    response: IAlternateItems | undefined;
}


/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    if(productId)
    {
        return new GetProductAlternateItemInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductAlternateItemAction(input: GetProductAlternateItemInput, ctx: Msdyn365.IActionContext): Promise<IGetProductAlternateItemData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    let proddtl:IGetAlternateItemWithServiceResponse = {product:undefined,response:undefined};
    try{
        const prod:ProductInput[] = new Array();
        prod.push(new ProductInput(input.productId,ctx.requestContext.apiSettings));
        var prodDtl = await getSimpleProductsAction(prod,ctx);
        const prodAlternates = await getProductInfoAsync({ callerContext: ctx, bypassCache: 'get' }, ctx,prodDtl[0].ItemId!);
        let altProduct:SimpleProduct|undefined;
        let alterProdAvailability: IProductInventoryInformation[] | null = null;
        let prodETA;
        if(prodAlternates && prodAlternates.length>0)
        {
            const productLookup:ProductLookupClause[] = new Array();
            const prodLookup:ProductLookupClause = {
                ItemId : prodAlternates[0].AltItemId};
                productLookup.push(prodLookup);
            const criteria:ProductSearchCriteria={
                Context:{CatalogId:ctx.requestContext.apiSettings.catalogId,ChannelId:ctx.requestContext.apiSettings.channelId},
                ItemIds:productLookup
            };
            var prodLists = await searchByCriteriaAsync({callerContext: ctx},criteria);
            if(prodLists && prodLists.length > 0)
            {
                var sampleProd = await getByIdAsync({callerContext: ctx}, prodLists[0].RecordId, ctx.requestContext.apiSettings.channelId);
                altProduct = sampleProd;
                const dt = new ProductAvailabilitiesForSelectedVariantInput(sampleProd.RecordId, ctx.requestContext.apiSettings.channelId);
                alterProdAvailability = await getProductAvailabilitiesForSelectedVariant(dt,ctx);
            const etaProdinpurt = new ProductEtaActionInput(sampleProd.RecordId,ctx.requestContext.apiSettings.channelId,undefined);
            const alterProdEta = await getProductEtaAction(etaProdinpurt,ctx);
                if(alterProdEta)
                {
                    prodETA = alterProdEta.etaObj;
                }
                await getProductAvailabilitiesForSelectedVariant(new ProductAvailabilitiesForSelectedVariantInput(input.productId, ctx.requestContext.apiSettings.channelId),ctx);
            }

        }
        var altProdDtl:IAlternateProduct | undefined = altProduct? {
            productDtl : altProduct,
            productAvailibility: alterProdAvailability,
            inventoryLabel: alterProdAvailability ? _getInventoryLabel(alterProdAvailability) : undefined,
            etaDetails: prodETA
        }: undefined;
        proddtl = {
            product : altProdDtl,
            response : prodAlternates[0]
        };
    }
    catch(e){
        console.log(e);
    }
     // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetProductAlternateItemData[]>('/get/example/id/1', 'get');
    return { respObj: proddtl };
}

const _getInventoryLabel = (productQty : IProductInventoryInformation[]|undefined)  => {
    if(productQty)
    {
        const newShippingQuantity = productQty.find(shipping => shipping.deliveryType === DeliveryMode.shipping);
        if(newShippingQuantity)
        {
            return newShippingQuantity.StockLevelLabel;
        }
    }
    return '';
};

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProductAlternateItemData>>getProductAlternateItemAction,
    // TODO: Give your data action a unique id
    id: 'GetProductAlternateItem',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
